import LeaveDurationWidget from 'domain/people/leave/createupdate/duration/LeaveDurationWidget';

export default LeaveDurationWidget;
